import { get, post } from '@/utils/httpHelper';

module.exports = {
  async callSaveQuestionnaire (params) {
    const url = `/esg/security/stakeholder/questionnaire/save`;
    const body = await post(url, params);
    return body.data;
  },
  async questionnaireInfo (assessmentId, language) {
    const url = `/esg/assessment/findAssessment/${assessmentId}/${language}`;
    const body = await get(url);
    return body.data;
  },
  async questionnaireList () {
    const url = `/esg/security/stakeholder/questionnaire/findActiveQuestionnaire`;
    const body = await get(url);
    return body.data;
  },
  async deleteQuestionnaire (updateAssessmentDtoStatus) {
    const url = `/esg/security/stakeholder/questionnaire/deleteQuestionnaire`;
    const body = await post(url, updateAssessmentDtoStatus);
    return body.data;
  },
  async confirmQuestionnaire (updateAssessmentDtoStatus) {
    const url = `/esg/security/stakeholder/questionnaire/confirmQuestionnaire`;
    const body = await post(url, updateAssessmentDtoStatus);
    return body.data;
  },
  async previewQuestionnaire (previewAssessmentId) {
    const url = `/esg/security/stakeholder/questionnaire/findQuestionnaireById/${previewAssessmentId}`;
    const body = await get(url);
    return body.data;
  },
  async findQuestionnaireResult () {
    const url = `/esg/security/stakeholder/questionnaire/findQuestionnaireResult`;
    const body = await get(url);
    return body.data;
  },
  async findQuestionnaireResultByConditions (params) {
    const url = `/esg/security/stakeholder/questionnaire/searchQuestionnaireResult`;
    const body = await get(url, params);
    return body.data;
  },
  async findUserInfo (params) {
    const url = `/esg/security/stakeholder/questionnaire/findUserInfoForResult`;
    const body = await get(url, params);
    return body.data;
  },
  async findSearchConditions () {
    const url = `/esg/security/stakeholder/questionnaire/findSearchConditions`;
    const body = await get(url);
    return body.data;
  },
  async  callSendRemindEmail (sendReminderEmailList) {
    const url = `/esg/security/stakeholder/questionnaire/sendRemindEmail`;
    const body = await post(url, sendReminderEmailList);
    return body.data;
  },
  async  remindAllStakeholder (params) {
    const url = `/esg/security/stakeholder/questionnaire/remindAllStakeholder`;
    const body = await post(url, params);
    return body.data;
  },
  async  callGenerateExcel (params) {
    const url = `/esg/security/stakeholder/questionnaire/generateReport/${params}`;
    const body = await get(url);
    return body.data;
  }
};



// WEBPACK FOOTER //
// ./src/repositories/answerer/questionnaire.repository.js